import React, { useState } from 'react';
import CharacterCreator from './CharacterCreator';
import CharacterList from './CharacterList';
import CharacterEdit from './CharacterEdit';
import CharacterProgression from './CharacterProgression';
import CharacterEquipment from './CharacterEquipment';
import { Character } from '../types/character';

const Characters: React.FC = () => {
  const [currentView, setCurrentView] = useState<'list' | 'create' | 'edit' | 'progression' | 'equipment'>('list');
  const [selectedCharacter, setSelectedCharacter] = useState<Character | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreateCharacter = () => {
    setCurrentView('create');
    setSelectedCharacter(null);
  };

  const handleEditCharacter = (character: Character) => {
    setSelectedCharacter(character);
    setCurrentView('edit');
  };

  const handleViewProgression = (character: Character) => {
    setSelectedCharacter(character);
    setCurrentView('progression');
  };

  const handleManageEquipment = (character: Character) => {
    setSelectedCharacter(character);
    setCurrentView('equipment');
  };

  const handleCharacterCreated = () => {
    setCurrentView('list');
    setSelectedCharacter(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleCharacterUpdated = () => {
    setCurrentView('list');
    setSelectedCharacter(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleCancel = () => {
    setCurrentView('list');
    setSelectedCharacter(null);
  };

  return (
    <div className="characters-page">
      {currentView === 'list' && (
        <CharacterList
          onCreateCharacter={handleCreateCharacter}
          onEditCharacter={handleEditCharacter}
          onViewProgression={handleViewProgression}
          onManageEquipment={handleManageEquipment}
          refreshTrigger={refreshTrigger}
        />
      )}

      {currentView === 'create' && (
        <CharacterCreator
          onCharacterCreated={handleCharacterCreated}
          onCancel={handleCancel}
        />
      )}

      {currentView === 'edit' && selectedCharacter && (
        <CharacterEdit
          character={selectedCharacter}
          onCharacterUpdated={handleCharacterUpdated}
          onCancel={handleCancel}
        />
      )}

      {currentView === 'progression' && selectedCharacter && (
        <CharacterProgression
          characterId={selectedCharacter.id}
          onBack={handleCancel}
        />
      )}

      {currentView === 'equipment' && selectedCharacter && (
        <CharacterEquipment
          characterId={selectedCharacter.id}
          onBack={handleCancel}
        />
      )}
    </div>
  );
};

export default Characters;